export const defaultPaginator = {
    allPages: 0,
    currentPage: 1,
    pageSize: 50,
    totalCount: 0,
}
